import { render, staticRenderFns } from "./FrzGroupObservation.vue?vue&type=template&id=3c7b622d"
import script from "./FrzGroupObservation.vue?vue&type=script&lang=js"
export * from "./FrzGroupObservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports